import { message } from "antd";
import axios from "axios";

export default async function handleUpdateCourse(playlistID, uid, items) {
  await axios.post(
    "/api/user/synccoure/uid/playlistID",
    {
      uid,
      playlistID,
      videos: items.map(({ snippet }) => ({
        videoId: snippet.resourceId.videoId,
        watched: false,
        title: snippet.title,
        description: snippet.description,
      })),
    },
    { timeout: 20000 },
  );
  message.success("New lessons added to your course.");
}
